export default __webpack_public_path__ + "static/media/credentials-inactive.a58bc6a6.svg";